import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/website/Home/Home';
import Projects from '../pages/website/Projects/Projects';
import City from '../pages/website/City/City';
import PropertyDetails from '../pages/website/PropertyDetails/PropertyDetails';
import About from '../pages/website/About/About';
import Contact from '../pages/website/Contact/Contact';
// import NotFound from '../pages/website/NotFound/NotFound';
import ScrollToTop from "../components/ScrollToTop/ScrollToTop";
const WebsiteRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:category" element={<Projects />} />
        <Route path="/city/:city" element={<City />} />
        <Route path="/property/:id" element={<PropertyDetails />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </>
  );
};

export default WebsiteRoutes;